import React, { useState } from 'react'
import classnames from 'classnames'

import { AuthorResume } from '@components/author-resume'

import styles from './styles.module.scss'

interface BiographyProps {
  name: string
  biography?: string
  avatarUrl?: string
  className?: string
}

export const Biography = ({
  name,
  biography,
  avatarUrl,
  className
}: BiographyProps) => {
  const [hideContent, setHideContent] = useState(true)

  return (
    <div
      className={
        biography
          ? classnames(className, styles.biographyContainer)
          : classnames(
              className,
              styles.biographyContainer,
              styles.noBorderBottom
            )
      }
    >
      {(name || avatarUrl) && (
        <AuthorResume name={name} avatarUrl={avatarUrl} />
      )}

      {biography && (
        <div className={styles.biographyContent}>
          <p>
            {biography.slice(0, 320)}

            {biography.length >= 320 && (
              <span className={hideContent ? 'hidden' : ''}>
                {biography.slice(320, 100000000)}
              </span>
            )}
            {biography.length >= 320 && (
              <span
                className="biography-show-more"
                onClick={() => setHideContent(!hideContent)}
              >
                {hideContent ? 'Ver mais' : 'Ver menos'}
              </span>
            )}
          </p>
        </div>
      )}
    </div>
  )
}
